__webpack_require__.p = "/b2c-frontier/_next/";